<template>
  <pancho-willies-default-section :section="section" :menu="menu"
                                  :class="containerClasses"
                                  class="menu--section-pancho__willies__specialty_drinks"></pancho-willies-default-section>
</template>

<script lang="ts">
/**
 * Custom component for Pancho & Willie's Specialty Drink menu section layout.
 *
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 1.0.1
 * @copyright  Copyright (C) 2023-2025, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 *
 *    2023-06-13 (1.0.0) (jhoward)
 *      - <panchoWilliesDessertSection> adds a simple center aligned menu type.
 *
 *  2025-04-08 (1.0.1) (jhoward)
 *    - Replace "menuVersion" prop with "menu" prop in <PanchoWillies_specialtyDrinkSection>.
 *    - Remove "visual_" prefix from class names in <PanchoWillies_specialtyDrinkSection>.
 */

import {defineComponent, PropType} from "vue";
import {Menu, MenuSection} from "../defs";
import PanchoWilliesDefaultSection from "./PanchoWillies_defaultSection.vue";

export default defineComponent({
  name: 'PanchoWillies_specialtyDrinkSection',
  components: {PanchoWilliesDefaultSection},
  props: {
    section: {
      type: Object as PropType<MenuSection>,
      required: true
    },
    menu: {
      type: Object as PropType<Menu>,
      required: true
    },
  },
  computed: {
    containerClasses(): {[key: string]: boolean} {
      return {
        'menu--section-pancho__willies_wine': /wine/i.test(this.section.ms_title)
      };
    }
  }
})
</script>

<style scoped>
.menu--section-pancho__willies__specialty_drinks:deep(.menu--section_title),
html .menu--section-pancho__willies__specialty_drinks:deep(.menu--section_subtitle) {
  text-align: center;
}

.menu--section-show_pricing_header.menu--section-pancho__willies__specialty_drinks:deep(.menu--section_subgroup_title span:nth-child(n + 2)) {
  text-align: center;
}

.menu--section-pancho__willies__specialty_drinks:deep(.menu--item_price) {
  text-align: center;
}

.menu--section-pancho__willies_wine:deep(.menu--item_price) {
  margin-left: 0;
}

.visual_menu--section.menu--section-pancho__willies_wine:deep(.menu--item_group) {
  position: relative;
}

.visual_menu--section.menu--section-pancho__willies_wine:deep(.menu--item_group::after) {
  content: '';
  position: absolute;
  right: 11.5%;
  top: 1em;
  bottom: -0.5em;
  width: 0.05em;
  background-color: #000000;
}
</style>